module.exports = __webpack_public_path__ + "img/milesight.e7dd470.gif";